import { Caption } from './styles';

import Button from '@/components/Button';
import PermissionComponent from '@/routes/PermissionComponent';

type Props = {
  readOnly: boolean;
  busy: boolean;
  error: string | null;
  onStart: () => void;
};

const SpanishEmpty = ({ readOnly, busy, error, onStart }: Props) => (
  <div
    data-testid="copyEsEmpty"
    style={{
      padding: '16px 20px',
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      alignItems: 'flex-start',
    }}
  >
    <div
      style={{
        background: '#FFF7E0',
        border: '1px solid #F0D58A',
        borderRadius: 6,
        padding: '10px 12px',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        alignSelf: 'stretch',
      }}
    >
      <strong>No Spanish text yet</strong>
      <span>
        Workers who use Spanish get the English text for this message until a
        Spanish version is published.
      </span>
    </div>
    <Caption>
      The Spanish draft starts from the English text. Drafts, lint checks,
      Publish and History work the same as in English, but separately for each
      language.
    </Caption>
    {error && (
      <span role="alert" style={{ color: '#B0030A', fontWeight: 600 }}>
        {error}
      </span>
    )}
    <span title={readOnly ? 'Tenant admin only' : undefined}>
      <PermissionComponent id="btn-lifecycle-copy-publish" showAsReadOnly>
        <Button
          a11yLabel="Start Spanish draft"
          label="Start Spanish draft"
          data-testid="copyStartEsBtn"
          disabled={readOnly || busy}
          isLoading={busy}
          loadingLabel="Starting..."
          onClick={onStart}
        />
      </PermissionComponent>
    </span>
  </div>
);

export default SpanishEmpty;
